<!--
 * @Description: 问诊金额
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-04 10:34:21
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span>问诊金额</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="()=>{dialog = false}">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title>
        <v-card-text class="black--text">
          <!-- 图文问诊 -->
          <v-card>
            <v-toolbar color="blue-grey lighten-3" dark dense flat>
              <v-toolbar-title class="body-2"> 图文问诊（元） </v-toolbar-title>
            </v-toolbar>
            <v-card-text> 患者通过文字、图片向您咨询，含5次发送消息的机会。 </v-card-text>
            <v-card-actions>
              <v-col cols="12" sm="9" md="9" class="input_">
                <v-text-field
                  label="输入图文问诊金额"
                  dense
                  v-model="once_fee_value"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  color="white"
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-btn text @click="product('once_fee')" >
                设置
                <v-icon large >mdi-chevron-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <p></p>
          <!-- 问诊服务包 -->
          <v-card>
            <v-toolbar color="indigo lighten-3" dark dense flat>
              <v-toolbar-title class="body-2"> 问诊服务包（元） </v-toolbar-title>
            </v-toolbar>
            <v-card-text> 患者含5次【图文问诊】机会，便于您长期跟踪服务。</v-card-text>
            <v-card-actions>
              <v-col cols="12" sm="9" md="9" class="input_">
                <v-text-field
                  label="输入问诊服务包金额"
                  dense
                  v-model="pack_fee_value"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  color="white"
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-btn text @click="product('pack_fee')" >
                设置
                <v-icon large >mdi-chevron-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-card-text>
        <v-card-actions>
          <!-- <v-btn color="primary" text @click="dialog = false">Close</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      doctorData:{
        once_product_no: "",
        pack_product_no: ""
      },
      once_fee_value: '',
      pack_fee_value: '',
      product_info: {

      }
    };
  },
  methods: {
    info(state, data) {
      // doctor_product_info
      this.dialog = state;
      this.doctorData = data;

      this.$axios({
        method: "get",
        url: `${this.$apis.URL.doctor_product_info}?product_nos[]=${this.doctorData.once_product_no}&product_nos[]=${this.doctorData.pack_product_no}`,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            window.console.log( req.data.datas )
            let list = req.data.datas;
            if( JSON.stringify(list) == "{}" ){
              this.$Dialog.getProductCheckResult_({ text: '您还没有设置资费金额！', timeout: 3000, snackbar: true });
            }else{
              list.forEach(element => {
                if( element.product_no == this.doctorData.once_product_no ){
                  this.once_fee_value = element.fee/100;
                }
                if( element.product_no == this.doctorData.pack_product_no ){
                  this.pack_fee_value = element.fee/100 ;
                }
              });
            }
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    },
    /* 设置问诊金额 */ 
    product(text){
      // doctor_product
      window.console.log( text )
      if( text=='once_fee' && !this.testNumber(this.once_fee_value )){
         return this.$Dialog.getProductCheckResult_({ text: ` 😐 设置金额请输入不小于1元的正整数`, timeout: 1000, snackbar: true });
      }
      if( text=='pack_fee'&& !this.testNumber(this.pack_fee_value )){
          return this.$Dialog.getProductCheckResult_({ text: ` 😐 设置金额请输入不小于1元的正整数`, timeout: 1000, snackbar: true });
      }
      let data = {}
      text=='once_fee'?data.once_fee = ~~(this.once_fee_value*100):text=='pack_fee'?data.pack_fee = ~~(this.pack_fee_value*100):data.once_fee = ~~(this.once_fee_value*100);
      if( text=='pack_fee' ){ data.pack_num=5; }
      this.$axios({
        method: "post",
        url: `${this.$apis.URL.doctor_product}`,
        data: data
      })
        .then(req => {
          if (req.data.result == 0) {
            // this.$Dialog.getProductCheckResult_({ text: `${ text=='once_fee'?'【图文问诊】金额设置成功！':'【问诊服务包】金额设置成功！' }`, timeout: 3000, snackbar: true });
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    },
    /* 验证金额 */ 
    isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if(regPos.test(val) || regNeg.test(val)) {
        return true;
        } else {
        return false;
        }
    },
    testNumber(val){
      var reg = /^[1-9]\d*$/;
      return reg.test(val);
    }
  }
};
</script>